// src/domains/user/user.usecases.ts

import { useNavigate } from 'react-router-dom';
import { useUserCustomersStore } from './userCustomers.store';
import { useEffect } from 'react';
import { useUserProfileStore } from './userProfile.store';
import { useUserCustomersApi, useUserProfileApi } from './user.api';
import { NAVBAR_SOURCES } from '@/components/AppComponents/Sidebar/NavBar/NavBarSources';

type UseCaseOptions = {
  enabled?: boolean;
};

export function useUserProfileUseCase(options?: UseCaseOptions) {
  const queryResult = useUserProfileApi(options);
  const { setUser } = useUserProfileStore();
  useEffect(() => {
    if (queryResult.data) {
      setUser(queryResult.data);
    }
  }, [queryResult.data, setUser]);

  return queryResult;
}

export function useUserCustomersUseCase(options?: UseCaseOptions) {
  const queryResult = useUserCustomersApi(options);
  const { setCustomers } = useUserCustomersStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (queryResult?.data?.customers) {
      setCustomers(queryResult.data.customers);
      if (queryResult.data.customers.length === 0) {
        navigate(NAVBAR_SOURCES.guest);
      }
    }
  }, [queryResult.data, setCustomers, navigate]);

  return queryResult;
}
